{
    "Omclient": "Client omnicanal :",
    "OmclientAgentValidation": "Un client Omnichannel a besoin d'un agent ACD au niveau des terminaux.",
    "DeviceHint": "Sélectionnez le terminal du superviseur pour autoriser les contrôles d'appel intégrés basés sur le navigateur.",
    "OmnichannelAgent": "Agent omnicanal :",
    "NoneSelected": "[Aucune sélection]",
    "NoAssociatedDevice": "[Aucun dispositif associé]",
    "NoAssociatedAgent": "[Pas d'agent ACD associé]",
    "ExtensionEndpoint_PermissionsNote": "Définir les autorisations du niveau d'accès de l'utilisateur.",
    "ExtensionEndpoint_CmEnvironment": "CME :",
    "ExtensionEndpoint_TelServer": "Serveur de téléphonie :",
    "ExtensionEndpoint_Partition": "Partition :",
    "ExtensionEndpoint_Device": "Dispositif :",
    "ExtensionEndpoint_AndOrAgent": "Et\/ou Agent :",
    "NAME": "ExtensionEndpoint",
    "ExtensionEndpoint_Validation_Professional_Device": "Un utilisateur professionnel doit avoir un point de terminaison de l'appareil défini",
    "ExtensionEndpoint_Validation_Professional_Device_MST": "Un utilisateur CXA non utilisé doit avoir un point de terminaison d'appareil défini",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent": "Un agent du centre d'appel doit avoir un point de terminaison défini.",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent_MST": "Un utilisateur CXA Premium doit avoir un point de terminaison d'agent défini",
    "ExtensionEndpoint_Validation_Professional_Device_MSTB": "Un utilisateur en temps réel doit avoir un point de terminaison de périphérique configuré.",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent_MSTB": "Un agent doit avoir un ensemble de points de terminaison d'agent"
}